// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"menuIcon-module--wrapper--2kndC","line":"menuIcon-module--line--hHqtE"};